import { LocalStorageService } from "../services/localStorage/localStorage.service";

export const MailSidebar = [
    { id: 0, menu: 'Inbox', icon: 'ri-mail-line', count_label: 'totalInbox', count: 0 },
    { id: 20, menu: 'Sent', icon: 'ri-mail-send-line', count_label: 'totalSent', count: 0 },
    // {id: 0, menu: 'Received Mail'},
    { id: 3, menu: 'URM', icon: 'ri-user-line', count_label: 'totalUrm', count: 0 },
    // {id: 10, menu: 'RM', icon: 'ri-user-line', count_label: 'totalRm', count: 0},
    { id: 1, menu: 'Management', icon: 'ri-user-voice-line', count_label: 'totalManagement', count: 0 },
    { id: 11, menu: 'Important', icon: 'ri-error-warning-line', count_label: 'totalImportant', count: 0 },
    { id: 12, menu: 'Done', icon: 'ri-mail-check-line', count_label: 'totalDone', count: 0 },
    { id: 2, menu: 'Junk', icon: 'ri-mail-close-line', count_label: 'totalJunk', count: 0 },
    // {id: 4, menu: 'IT'},
    // {id: 6, menu: 'Crizac'},
    // {id: 5, menu: 'Crizac Global'},
    // {id: 7, menu: 'UCOL'},
    // {id: 8, menu: 'Others'},
]

export function getMailSidebar(localStorageService: LocalStorageService) {
    const sidebarConfig = [...MailSidebar];
    
    if (localStorageService.isMMR()) {
        sidebarConfig.splice(5, 0, {
            id: 7,
            menu: 'MMR Done',
            icon: 'ri-mail-line',
            count_label: 'totalMMRDoneMails',
            count: 0,
        });
    }
    
    return sidebarConfig;
}


export const MailSidebarMailBox = [
    { id: 0, menu: 'Inbox', icon: 'ri-mail-line', count_label: 'totalInbox', count: 0, myMails: false },
    { id: 2, menu: 'Sent', icon: 'ri-mail-send-line', count_label: 'totalSent', count: 0 },
    { id: 8, menu: 'Draft', icon: 'ri-draft-line', count_label: 'totalDrafts', count: 0 },
    { id: 4, menu: 'Important', icon: 'ri-error-warning-line', count_label: 'totalImportant', count: 0 },
    { id: 1, menu: 'Done', icon: 'ri-archive-line', count_label: 'totalArchive', count: 0, myMails: false },
    { id: 5, menu: 'Shared with me', icon: 'ri-share-line', count_label: 'totalShared', count: 0 },
    { id: 6, menu: 'Junk', icon: 'ri-mail-forbid-line', count_label: 'totalJunk', count: 0 },
]

export function getMailSidebarMailBox(localStorageService: LocalStorageService) {
    const sidebarConfig = [...MailSidebarMailBox];
    
    if (localStorageService.isMMR()) {
        sidebarConfig.splice(5, 0, {
            id: 7,
            menu: 'MMR Done',
            icon: 'ri-mail-line',
            count_label: 'totalMMRDoneMails',
            count: 0
        });
    }
    
    return sidebarConfig;
}


export const AllMailSidebarMailBox = [
    { id: 0, menu: 'Inbox', icon: 'ri-mail-line', count_label: 'totalInbox', count: 0, myMails: true },
    { id: 2, menu: 'Sent', icon: 'ri-mail-send-line', count_label: 'totalSent', count: 0 },
    { id: 8, menu: 'Draft', icon: 'ri-draft-line', count_label: 'totalDrafts', count: 0 },
    { id: 4, menu: 'Important', icon: 'ri-error-warning-line', count_label: 'totalImportant', count: 0 },
    { id: 1, menu: 'Done', icon: 'ri-archive-line', count_label: 'totalArchive', count: 0, myMails: false },
    { id: 6, menu: 'Junk', icon: 'ri-mail-forbid-line', count_label: 'totalJunk', count: 0 },
]

export function getAllMailSidebarMailBox(localStorageService: LocalStorageService) {
    const sidebarConfig = [...AllMailSidebarMailBox];
    
    if (localStorageService.isMMR()) {
        sidebarConfig.splice(5, 0, {
            id: 7,
            menu: 'MMR Done',
            icon: 'ri-mail-line',
            count_label: 'totalMMRDoneMails',
            count: 0
        });
    }
    
    return sidebarConfig;
}

// export const MailTypes = {
//     inbox: {type: 'Inbox', id: 0},
//     sent: {type: 'Sent', id: 2},
//     important: {type: 'Important', id: 4},
//     archived: {type: 'Archived', id: 1},
//     share: {type: 'Share', id: 5},
// }

export const MailTypes = [
    { id: 4, type: 'Important', msg: 'Important' },
    { id: 1, type: 'Done', msg: 'Done' },
    { id: 5, type: 'Share', msg: 'Shared' },
    { id: 6, type: 'Junk', msg: 'Junk' },
    { id: 7, type: 'MMR Done', msg: 'MMR Done' },
    { id: 8, type: 'Draft', msg: 'Draft' },
    { id: 0, type: 'Inbox', msg: 'Inbox' },
    { id: 10, type: 'Remove', msg: 'Remove' },
]

export const MailTypeIds = {
    inbox: 0,
    archived: 1,
    MMRarchived: 7,
    sent: 2,
    important: 4,
    share: 5,
    junk: 6,
    draft: 8,
    folders: 9,
    remove: 10,
}

export const MailCommon = {
    selected_domain: 'selected_domain_mails',
    discard: 'discard',
    continue: 'continue',
    missing_subject: 'missing_subject',
    send: 'send',
    dont_send: 'dont_send',
    large_file: 'large_file'
}

export const maxAttachmentSize: number = 10; // 10MB